module.exports = __webpack_public_path__ + "img/syukyaku-EC-websit-back001.228cc97f.jpg";